import _extends from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Slider from 'react-slick';
import Link from 'next/link';
import { HeroPrev, Banner, BannerWrapper, HeroNext, LinkWrapper } from "./style";
var carouselSettings = {
  infinite: true,
  autoplay: true,
  swipeToSlide: true,
  dots: false,
  arrows: false,
  draggable: true,
  slidesToShow: 1,
  autoplaySpeed: 5000,
  centerMode: true,
  variableWidth: true
};
var Hero = /*#__PURE__*/function (_Component) {
  function Hero() {
    var _this;
    _classCallCheck(this, Hero);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, Hero, [].concat(args)), _this.next = function () {
      _this.slider.slickNext();
    }, _this.previous = function () {
      _this.slider.slickPrev();
    }, _assertThisInitialized(_this)));
  }
  _inherits(Hero, _Component);
  return _createClass(Hero, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var heroes = this.props.heroes;
      return __jsx(BannerWrapper, null, __jsx(HeroPrev, {
        onClick: this.previous
      }), __jsx(Slider, _extends({}, carouselSettings, {
        ref: function ref(arg) {
          _this2.slider = arg;
        }
      }), heroes.map(function (hero, i) {
        return __jsx(LinkWrapper, {
          key: i
        }, __jsx(Link, {
          href: "/".concat(hero.linkUrl)
        }, __jsx(Banner, {
          mobileImage: hero.mobileImage,
          desktopImage: hero.desktopImage
        })));
      })), __jsx(HeroNext, {
        onClick: this.next
      }));
    }
  }]);
}(Component);
Hero.defaultProps = {
  heroes: []
};
export default Hero;